import { Injectable } from '@angular/core'
import { IEmployee } from '../model/employee';
import { APIService } from '../services/api.service'
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
@Injectable()
export class SlotsService {
    httpOptions: any = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        })
    }
    employee: IEmployee;
    constructor(private _http: HttpClient, private _apiServices: APIService) { }
    // Method for get employee list

    getSlots(empid): Observable<any> {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        console.log('loginUser')
        console.log(loginUser)
        let data = {
            "empid": empid,
            "token": loginUser.token
        }
        let body = JSON.stringify(data);

        return this._http.post(environment.apiURL + "/api/getemployeeSlots", body, this.httpOptions)
            .catch(this.handleError);

    }

    changeSlot(id, isactive): Observable<any> {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        console.log('loginUser')
        console.log(loginUser)
        let data = {
            "id": id,
            "isactive": isactive,
            "token": loginUser.token
        }
        let body = JSON.stringify(data);

        return this._http.post(environment.apiURL + "/api/changeemployeeSlots", body, this.httpOptions)
            .catch(this.handleError);

    }

    // Method for Save employee details
    saveSlots(slots, localtimeZone) {

        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        let data = slots;
        data.localtimeZone = localtimeZone;
        console.log('localtimeZone ', data.localtimeZone);
        let body = JSON.stringify(data);
        console.log('data in service ', body);
        return this._http.post(environment.apiURL + "/api/createSlots", body, this.httpOptions)
            .catch(this.handleError);
    }


    handleError(error: Response) {
        console.log(error);
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// ./src/app/services/slots.services.ts